export enum FBOProfileUpdateEnum {
    MEMBER_NAME_CHANGE = 'MEMBER_NAME_CHANGE',
    MEMBER_EMAIL_CHANGE = 'MEMBER_EMAIL_CHANGE',
    MEMBER_HOME_COUNTRTY_CHANGE = 'MEMBER_HOME_COUNTRTY_CHANGE',
    MEMBER_MAILING_ADDRESS_CHANGE = 'MEMBER_MAILING_ADDRESS_CHANGE',
    BONUS_PAY_BANK_DETAILS_CHANGE = 'BONUS_PAY_BANK_DETAILS_CHANGE',
    BONUS_PAY_IBAN_OR_SWIFT_CHANGE = 'BONUS_PAY_IBAN_OR_SWIFT_CHANGE',
    MEMBER_NEW_COUNTRY_ELIGIBILITY = 'MEMBER_NEW_COUNTRY_ELIGIBILITY',
    MEMBER_VATID_CHANGE = 'MEMBER_VATID_CHANGE',
    MEMBER_PHONE_CHANGE = 'MEMBER_PHONE_CHANGE'
}



// WEBPACK FOOTER //
// ./src/app/common/enums/fboprofile-update-enum.ts